import api from '../../api/codes'
import {
  CODES_LIST,
  CODES_ADD,
  CODES_ENABLE,
  CODES_UPDATE
} from '../actions/codes'

const state = {
  codes: []
}

const getters = {
  codes: state => state.codes || []
}

const actions = {
  [CODES_LIST]: async function ({commit, state}) {
    if (state.codes && state.codes.length) {
      return 200
    }
    try {
      const res = await api.getAllCodes()
      commit(CODES_LIST, res)
      return res.status
    } catch (err) {
      console.log(err)
      return err.response.status
    }
  },
  [CODES_ADD]: async function ({commit}, codes) {
    try {
      const res = await api.addCodes(codes)
      commit(CODES_ADD, { codes: res[0] })
      return res
    } catch (err) {
      console.log(err)
      return null
    }
  },
  [CODES_ENABLE]: async function ({commit}, id) {
    try {
      const res = await api.enableCodes(id)
      for (let i = 0; i < state.codes.length; i++) {
        if (state.codes[i].id === res[0].id) {
          commit(CODES_UPDATE, { i, codes: res[0] })
          break
        }
      }
      return res
    } catch (err) {
      console.log(err)
      return null
    }
  }
}

const mutations = {
  [CODES_LIST]: (state, params) => {
    state.codes = params.data.data
  },
  [CODES_ADD]: (state, params) => {
    state.codes.unshift(params.codes)
  },
  [CODES_UPDATE]: (state, params) => {
    state.codes[params.i] = params.codes
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/codes.js